export default __webpack_public_path__ + "static/expert_on_the_way_meet-e31cd2d2734ba69078f7be013a83ba92.svg";